import type { FC } from "react";
import React from "react";

import clsx from "clsx";

import { Label, Rating as RatingComponent } from "@busbud/horizon";

import { useAppContext } from "@app/helpers/hooks";

interface Props {
  rating: number;
  total_reviews?: number | null;
  size?: "sm" | "md" | "lg";
  show_label?: boolean;
  className?: string;
}

export const Rating: FC<Props> = ({
  rating,
  size = "md",
  total_reviews,
  show_label,
  className
}) => {
  const { translator, intlProvider } = useAppContext();

  // round number to closest half
  rating = Math.round(rating * 2) / 2;

  return (
    <>
      <div className={clsx("flex flex-nowrap items-center", className)}>
        <RatingComponent
          size={size}
          value={rating}
          hiddenLabel={translator.t(
            "!partner.partner-review.avg-overall-rating",
            {
              avg_overall_rating: rating,
              max_stars: 5
            }
          )}
        />
        {!!show_label && (
          <>
            <Label
              as="span"
              size="xl"
              noWrap
              className="pl-150 pr-200 text-color-primary"
            >{`${rating}/5`}</Label>
            <Label as="span" size="sm" noWrap className="text-color-primary">
              {translator.t("!results.filters.operator-reviews", {
                ratings: intlProvider.formatNumber(total_reviews || 0)
              })}
            </Label>
          </>
        )}
      </div>
    </>
  );
};
